import React from 'react'
import PropTypes from 'prop-types'
import PlaceholderIcon from './PlaceholderIcon'

interface BaseSupplierIconProps {
  id: string | number // prefer string, but number is provided for backwards compatibility
  name: string
  logoUrl?: string
}

interface SupplierImageProps extends BaseSupplierIconProps {}

function SupplierImage ({ id, name, logoUrl }: SupplierImageProps): React.ReactElement {
  if (logoUrl == null) {
    return <PlaceholderIcon id={id} name={name} />
  }

  return (
    <img
      src={logoUrl}
      alt={`Logo for ${name}`}
      className='supplier-icon'
    />
  )
}

SupplierImage.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string.isRequired,
  logoUrl: PropTypes.string
}

export enum IconVariant {
  XSMALL = 'x-small',
  SMALL = 'small',
  LARGE = 'large pro-closest-shadow',
  XLARGE = 'x-large pro-closest-shadow'
}

interface SupplierIconProps extends BaseSupplierIconProps {
  variant: IconVariant
}

export default function SupplierIcon ({ variant = IconVariant.SMALL, ...imageProps }: SupplierIconProps): React.ReactElement {
  return (
    <div className={`supplier-icon-container ${variant}`}>
      <SupplierImage {...imageProps} />
    </div>
  )
}

SupplierIcon.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string.isRequired,
  logoUrl: PropTypes.string,
  isLarge: PropTypes.bool
}
